// extracted by mini-css-extract-plugin
export default {"floatingWindowWp":"index_floatingWindowWp__4hjI","linear":"index_linear_zspxp","dragBall":"index_dragBall_GNrmZ"};